import { createFileRoute } from '@tanstack/react-router'
import { SupplierDetailPage } from '@/pages/supplier-detail'

export const Route = createFileRoute('/_authenticated/suppliers/$supplierId')({
  staticData: { title: 'Supplier' },
  component: SupplierDetailRoute,
})

function SupplierDetailRoute() {
  const { supplierId } = Route.useParams()
  return <SupplierDetailPage supplierId={supplierId} />
}
